import marketList from "./marketsList";
import cloneDeep from "lodash/cloneDeep";

const marketDefinitions = (() => {
  let markets = cloneDeep(marketList);

  const svc = {
    updateMarketLanguages: (market, country) => {
      market.languages.forEach(ml => {
        let cLangMatch = country.languages.filter(cl => {
          return ml.code === cl.code;
        });

        if (cLangMatch.length) {
          cLangMatch = cLangMatch[0];
          ml.default = cLangMatch.default;
          if (!ml.name) ml.name = cLangMatch.name;
        } else {
          ml.default = false;
          if (ml.code === "en") {
            ml.name = "English";
          }
        }
      });
    },
    updateMarketCurrencies: (market, country) => {
      market.currencies = Object.assign([], country.currencies);
    },
    getMarketByCode: (markets, marketCode) => {
      let match = markets.filter(m => {
        return m.countryCode === marketCode;
      });
      if (match.length) {
        return match[0];
      } else {
        return false;
      }
    }
  };

  return {
    getMarketDefinitions: function() {
      return markets;
    },
    getMarketRegions: function() {
      return [...new Set(markets.filter((market=>market.region)).map(market=>market.region))]
    },
    getExternalLink: function(marketCode) {
      var market = markets.filter(sc => {
        return sc.countryCode.toLowerCase() === marketCode.toLowerCase();
      });

      if (
        market.length &&
        market[0].externalSite &&
        market[0].languages[0].externalLink
      ) {
        return market[0].languages[0].externalLink; //return external link to primary language
      }
      return false;
    },
    getMarketByCode: function(markets, marketCode) {
      return svc.getMarketByCode(markets, marketCode);
    },
    enrichMarketDefinitions: function(apiCountryData) {
      let countries = cloneDeep(apiCountryData);
      markets.forEach(m => {
        let countryMatch = countries.filter(c => {
          return (m.countryCode === "AE" ? "UE" : m.countryCode) === c.alpha2;
        });
        //PR does not come back from api call but is in marketList
        if (!m.countryCode3) m.countryCode3 = countries.find(c => c.alpha2 === m.countryCode).alpha3
        if (countryMatch.length) {
          countryMatch = countryMatch[0];
          svc.updateMarketLanguages(m, countryMatch);
          svc.updateMarketCurrencies(m, countryMatch);
        }
      });
      return markets;
    },
    getMarketCurrency: function(markets, country) {
      let marketMatch = markets.filter(m => {
        return m.countryCode === country;
      });
      if (marketMatch.length) {
        let market = marketMatch[0];
        let res = {
          code: market.currencies.length ? market.currencies[0].code : '',
          symbol: market.currencies.length ? market.currencies[0].symbol : ''
        };
        return res;
      }
      return false;
    },
    getCatalogType: function(markets, country) {
      let marketMatch = markets.filter(m => {
        return m.countryCode === country;
      });
      if (marketMatch.length) {
        let market = marketMatch[0];
        return market.catalogType || "Enrollment";
      }
      return "Enrollment";
    },
    hasPrivacyPolicy: function(country) {
      const market = marketList.find(market => market.countryCode === country);

      if(!market) {
        return false;
      }

      return market.hasPrivacyPolicy;
    },
    hasLongTermsConditions: function(country) {
      const market = marketList.find(market => market.countryCode === country);

      if(!market) {
        return false;
      }

      return market.hasLongTermsConditions;
    },
    isRTL: (language) => {
        return ["ar"].includes(language.toLowerCase());
    },
    getMarketDateFormat: function(country) {
      const market = marketList.find(market => market.countryCode === country);
      return market.dateFormat || "MDY";
    },
  };
})();
export default marketDefinitions;



// WEBPACK FOOTER //
// ./src/services/markets/marketsSvc.js